// src/pages/Residential/Optional/Referral/ReferralForm.js
import React from "react";

const ReferralForm = ({ formData, handleChange }) => {
    return (
        <>
            <div className="p-3" style={{ maxHeight: "65vh", overflowY: "auto", scrollbarWidth: "thin" }}>
                <div className="accordion" id="referralAccordion">
                    {/* General Details */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header">
                            <button className="accordion-button fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#generalDetails">
                                General Details
                            </button>
                        </h2>
                        <div id="generalDetails" className="accordion-collapse collapse show">
                            <div className="accordion-body pt-3">
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <div className="form-floating form-floating-outline">
                                            <input type="date" className="form-control" name="date" value={formData.date || ""} onChange={handleChange} />
                                            <label>Date</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating form-floating-outline">
                                            <input type="text" className="form-control" name="referringFacility" value={formData.referringFacility || ""} onChange={handleChange} />
                                            <label>Referring Facility</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Patient Details */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header">
                            <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#patientDetails">
                                Patient Details
                            </button>
                        </h2>
                        <div id="patientDetails" className="accordion-collapse collapse">
                            <div className="accordion-body pt-3">
                                <div className="row g-3">
                                    <div className="col-md-3">
                                        <div className="form-floating form-floating-outline">
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="patientName"
                                                value={formData.patientName || ""}
                                                onChange={handleChange}
                                                readOnly={!!formData.patientId || !!formData.patient_id}
                                            />
                                            <label>Patient Name</label>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-floating form-floating-outline">
                                            <input
                                                type="date"
                                                className="form-control"
                                                name="dob"
                                                value={formData.dob || ""}
                                                onChange={handleChange}
                                                readOnly={!!formData.patientId || !!formData.patient_id}
                                            />
                                            <label>DOB</label>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-floating form-floating-outline">
                                            <select
                                                className="form-select"
                                                name="gender"
                                                value={formData.gender?.toLowerCase() || ""}
                                                onChange={handleChange}
                                                disabled={!!formData.patientId || !!formData.patient_id}
                                            >
                                                <option value="">Select Gender</option>
                                                <option value="male">Male</option>
                                                <option value="female">Female</option>
                                                <option value="other">Other</option>
                                            </select>
                                            <label>Gender</label>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-floating form-floating-outline">
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="contact"
                                                value={formData.contact || ""}
                                                onChange={handleChange}
                                                readOnly={!!formData.patientId || !!formData.patient_id}
                                            />
                                            <label>Contact</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Medical Details */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header">
                            <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#medicalDetails">
                                Medical Details
                            </button>
                        </h2>
                        <div id="medicalDetails" className="accordion-collapse collapse">
                            <div className="accordion-body pt-3">
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <div className="form-floating form-floating-outline">
                                            <input type="text" className="form-control" name="primaryComplaintDiagnosis" value={formData.primaryComplaintDiagnosis || ""} onChange={handleChange} />
                                            <label>Primary Complaint / Diagnosis</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating form-floating-outline">
                                            <input type="text" className="form-control" name="currentMedication" value={formData.currentMedication || ""} onChange={handleChange} />
                                            <label>Current Medication</label>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-floating form-floating-outline">
                                            <textarea className="form-control" name="historyPreviousTreatment" value={formData.historyPreviousTreatment || ""} onChange={handleChange} rows="4" />
                                            <label>History / Previous Treatment</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Referral Information */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header">
                            <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#referralInformation">
                                Referral Information
                            </button>
                        </h2>
                        <div id="referralInformation" className="accordion-collapse collapse">
                            <div className="accordion-body pt-3">
                                <div className="row g-3">
                                    <div className="col-md-3">
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="furtherManagement" id="specialistOpinion" value="Specialist Opinion" checked={formData.furtherManagement === "Specialist Opinion"} onChange={handleChange} />
                                            <label className="form-check-label" htmlFor="specialistOpinion">Specialist Opinion</label>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="furtherManagement" id="admission" value="Admission" checked={formData.furtherManagement === "Admission"} onChange={handleChange} />
                                            <label className="form-check-label" htmlFor="admission">Admission</label>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="furtherManagement" id="investigation" value="Investigation" checked={formData.furtherManagement === "Investigation"} onChange={handleChange} />
                                            <label className="form-check-label" htmlFor="investigation">Investigation</label>
                                        </div>
                                    </div>
                                    <div className="col-md-3 d-flex align-items-center">
                                        <div className="form-check me-2">
                                            <input className="form-check-input" type="radio" name="furtherManagement" id="otherManagement" value="Other" checked={formData.furtherManagement === "Other"} onChange={handleChange} />
                                            <label className="form-check-label" htmlFor="otherManagement">Other</label>
                                        </div>
                                        {formData.furtherManagement === "Other" && (
                                            <input type="text" className="form-control" name="otherManagement" value={formData.otherManagement || ""} onChange={handleChange} placeholder="Specify" />
                                        )}
                                    </div>
                                </div>
                                <div className="row g-3 mt-3">
                                    <div className="col-md-6">
                                        <div className="form-floating form-floating-outline">
                                            <input type="text" className="form-control" name="referredTo" value={formData.referredTo || ""} onChange={handleChange} />
                                            <label>Referred To (Facility Name)</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating form-floating-outline">
                                            <input type="text" className="form-control" name="departmentConsultant" value={formData.departmentConsultant || ""} onChange={handleChange} />
                                            <label>Department / Consultant (if any)</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Patient/Family Acknowledgment */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header">
                            <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#acknowledgment">
                                Patient/Family Acknowledgment
                            </button>
                        </h2>
                        <div id="acknowledgment" className="accordion-collapse collapse">
                            <div className="accordion-body pt-3">
                                <div className="form-check mb-3">
                                    <input className="form-check-input" type="checkbox" name="acknowledgmentAccepted" checked={formData.acknowledgmentAccepted} onChange={handleChange} id="acknowledgmentAccepted" />
                                    <label className="form-check-label" htmlFor="acknowledgmentAccepted">I acknowledge and accept the referral.</label>
                                </div>
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <div className="form-floating form-floating-outline">
                                            <input type="text" className="form-control" name="acknowledgmentName" value={formData.acknowledgmentName || ""} onChange={handleChange} />
                                            <label>Name</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-floating form-floating-outline">
                                            <input type="text" className="form-control" name="acknowledgmentRelation" value={formData.acknowledgmentRelation || ""} onChange={handleChange} />
                                            <label>Relation</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-floating form-floating-outline">
                                            <input type="datetime-local" className="form-control" name="acknowledgmentDateTime" value={formData.acknowledgmentDateTime || ""} onChange={handleChange} />
                                            <label>Date & Time</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ReferralForm;